import { render, staticRenderFns } from "./CloseReorderProduductsFlowWidget.vue?vue&type=template&id=8fcd8eb2&scoped=true"
import script from "./CloseReorderProduductsFlowWidget.vue?vue&type=script&lang=js"
export * from "./CloseReorderProduductsFlowWidget.vue?vue&type=script&lang=js"
import style0 from "./CloseReorderProduductsFlowWidget.vue?vue&type=style&index=0&id=8fcd8eb2&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8fcd8eb2",
  null
  
)

export default component.exports